import { useState, useCallback } from 'react';
import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Box,
    Stack,
} from '@chakra-ui/react';
import AccordionItemHandler from 'components/forms/new/AccordionItemHandler';
import { invoiceFormatList } from '../../constants';
import InvoiceFormatFields from '../../../../sharedComponents/billing/InvoiceFormatFields';
import { FORM_FIELD_PATHS } from '../../constants';
import { usePartnerForm } from '../../hooks/usePartnerForm';

const PartnerBillingInvoiceFormat = ({
    errors,
    touched,
    billingState,
}) => {
    const { formData, updateFormData } = usePartnerForm();

    const setBillingState = useCallback(
        (payload) => {
            updateFormData(FORM_FIELD_PATHS.BILLING_SETTINGS, {
                ...formData.partnerBillingSettings,
                ...payload,
            });
        },
        [updateFormData, formData],
    );
    const [globalCursorPosition, setGlobalCursorPosition] = useState({});

    return (
        <AccordionItemHandler
            index={2}
            key="partnerBillingInvoiceFormat"
            label="Invoice Format"
            errors={errors}
            touched={touched}
            defaultIsOpen={true}>
            <Accordion allowMultiple defaultIndex={[0]}>
                {invoiceFormatList?.map(({ title, contents }) => (
                    <AccordionItem key={title}>
                        <AccordionButton>
                            <Box flex="1" textAlign="left" fontWeight="bold">
                                {title}
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel pb={4}>
                            <Stack spacing={3}>
                                {contents?.map((item) => (
                                    <InvoiceFormatFields
                                        key={item.format.label}
                                        globalCursorPosition={
                                            globalCursorPosition
                                        }
                                        billingState={billingState}
                                        setBillingState={setBillingState}
                                        setGlobalCursorPosition={
                                            setGlobalCursorPosition
                                        }
                                        {...item}
                                    />
                                ))}
                            </Stack>
                        </AccordionPanel>
                    </AccordionItem>
                ))}
            </Accordion>
        </AccordionItemHandler>
    );
};

export default PartnerBillingInvoiceFormat;
